import { render, staticRenderFns } from "./TicketsFiles.vue?vue&type=template&id=a7f5a140&scoped=true"
import script from "./TicketsFiles.vue?vue&type=script&lang=js"
export * from "./TicketsFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f5a140",
  null
  
)

export default component.exports